module.exports = __webpack_public_path__ + "img/resource-tech-image-54.37d69949.jpg";